import React from "react";
import wireImage from "../../../semantic/dist/themes/fibrestream/assets/images/wire.png";
import wireXsImage from "../../../semantic/dist/themes/fibrestream/assets/images/logo-group.png";

const TopSites = () => (
  <section className="ui inverted vertical segment center aligned top-sites">
    <div className="ui container">
      <div className="itc title--36">
        Peered with <span className="itc-mdbold">top sites</span>
      </div>
      <p className="desc text-grey3">For even faster browsing</p>
      <div className="drop-radial ts-image">
        <button className="ui button itc-mdbold btn--grad mr-0">
          Fibre<span className="itc-std-md normal">Stream</span>
          <div className="blink-light">
            <div className="ui list horizontal">
              <div className="item" />
              <div className="item" />
              <div className="item" />
              <div className="item" />
              <div className="item" />
              <div className="item" />
            </div>
          </div>
        </button>
      </div>
      <img
        className="ui centered image computer only grid mx-auto"
        src={wireImage}
        alt="Logo Group"
        width="910"
        height="240"
      />

      <img
        className="ui centered image tablet only mobile only grid mx-auto"
        src={wireXsImage}
        alt="Logo Group"
        width="345"
        height="257"
      />
      <p className="text-grey4 f-size--14 itc-std-md legal-text">All product and company names are trademarks™ or registered® trademarks of their respective holders. Use of them does not imply any affiliation with or endorsement by them.</p>
    </div>
  </section>
);

export default TopSites;



// WEBPACK FOOTER //
// ./src/components/home/top-sites/TopSites.js